"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TooltipCoachmark = _interopRequireDefault(require("./TooltipCoachmark"));

var _Icons = _interopRequireDefault(require("./Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Textarea = function Textarea(props) {
  var _useState = (0, _react.useState)("fieldClass-" + Math.random() * 1000000),
      _useState2 = _slicedToArray(_useState, 2),
      fieldClass = _useState2[0],
      setFieldClass = _useState2[1];

  var valid = props.valid,
      message = props.message,
      className = props.className,
      style = props.style,
      id = props.id,
      label = props.label,
      fieldStyle = props.fieldStyle,
      rest = _objectWithoutProperties(props, ["valid", "message", "className", "style", "id", "label", "fieldStyle"]);

  var classes = (0, _classnames["default"])("input-field", "textarea-field", valid, fieldStyle, {
    "filled": props.value,
    "disabled": props.disabled
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "textarea-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style,
    id: id
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "field-placeholder"
  }, label), /*#__PURE__*/_react["default"].createElement("textarea", _extends({
    className: fieldClass
  }, rest)), props.fieldStyle === "textarea-dashed" && /*#__PURE__*/_react["default"].createElement("svg", {
    className: "svg-dashed {{ classes }}",
    height: "1px",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0",
    y1: "1",
    x2: "400",
    y2: "1",
    stroke: "black"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "field-message ".concat(message ? "show" : "")
  }, message), valid === "error" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClass),
    state: "show",
    color: "red"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-error",
    className: "the-svg-icons"
  })), valid === "empty" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClass),
    state: "show",
    color: "grey"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow",
    className: "the-svg-icons"
  }))));
};

Textarea.propTypes = {
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  valid: _propTypes["default"].oneOf(["valid", "error", "empty", '']),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  maxLength: _propTypes["default"].number,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  fieldStyle: _propTypes["default"].oneOf(["text-field-outline", "text-field-outline-ext-1", "textarea-dashed"])
};
Textarea.defaultProps = {
  name: "",
  value: undefined,
  label: null,
  placeholder: "",
  valid: "",
  message: null,
  onChange: function onChange() {},
  className: "",
  style: {},
  id: null,
  tabIndex: 1,
  maxLength: 400,
  fieldStyle: "text-field-outline"
};
var _default = Textarea;
exports["default"] = _default;